module.exports = __webpack_public_path__ + "static/img/menu3.e7ffb24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/menu3.png
// module id = Y02p
// module chunks = 11